// ------------------------------------------------------------------------------
// name: trnansformUrl
// author: mudas
// created: 2025/5/6
// ------------------------------------------------------------------------------

/*
/api/v1/user/reimbursementInformationList   -> /api/v1/backend/user/reimbursementInformationList
/api/v1/artist/inviteArtist                 -> /api/v1/backend/artist/inviteArtist
/api/v1/artist/inviteMediaUser              -> /api/v1/backend/artist/inviteMediaUser
/api/v2/task/requirement/list               -> /api/v1/backend/artist/requirement/list
/api/v2/work/style/list                     -> /api/v1/backend/artist/style/list
/api/v1/user/enterpriseCertify/bankList     -> /api/v1/backend/enterpriseAuth/bankList
/api/v1/user/enterpriseCertify/subBankList  -> /api/v1/backend/enterpriseAuth/subBankList
 */

/**
 * 前后台共用的 api url
 * - string 则完全匹配
 * - 支持正则匹配
 * - 输入前台原始地址，后台地址会自动插入 backend 节点
 */
const SharedPath: (string | RegExp | [string | RegExp, string])[] = [
  '/api/v1/user/reimbursementInformationList',
  '/api/v1/artist/inviteArtist',
  '/api/v1/artist/inviteMediaUser',
  ['/api/v2/task/requirement/list', '/api/v1/backend/artist/requirement/list'],
  ['/api/v2/work/style/list', '/api/v1/backend/artist/style/list'],
  ['/api/v1/user/enterpriseCertify/bankList', '/api/v1/backend/enterpriseAuth/bankList'],
  ['/api/v1/user/enterpriseCertify/subBankList', '/api/v1/backend/enterpriseAuth/subBankList'],
];

export const trnansformUrlInterceptor = (config) => {
  if (import.meta.env.VITE_PLATFORM === 'manager') {
    const originalURL = config.url || '';

    if (!originalURL) return config;

    // 遍历所有需要处理的 path
    for (const path of SharedPath) {
      const isBackendURL = /^\/?api\/v\d+\/backend/i.test(originalURL);

      const srcPath = Array.isArray(path) ? path[0] : path;
      const destPath = Array.isArray(path) ? path[1] : '';

      if (
        !isBackendURL &&
        (typeof srcPath === 'string' ? originalURL.startsWith(srcPath) : srcPath.test(originalURL))
      ) {
        // 若指定了目标服务地址，则直接替换（主要针对无规律替换，服务地址变化过大的情况）
        config.url = destPath || originalURL.replace(/^\/?api\/(v\d+)\//i, '/api/v1/backend/');
        break; // 替换完成，不再二次检测替换
      }
    }
  }

  return config;
};
